import type { ComponentProps } from "react";

import TopicReview from "./topic-review";
import TopicSport from "./topic-sport";
import TopicFood from "./topic-food";
import TopicTravel from "./topic-travel";
import TopicPregnancy from "./topic-pregnancy";
import TopicChildren from "./topic-children";
import TopicEveryday from "./topic-everyday";

export type TopicIconVariant =
  | "review"
  | "sport"
  | "food"
  | "travel"
  | "pregnancy"
  | "children"
  | "everyday";

type TopicIconProps = {
  variant?: TopicIconVariant;
} & ComponentProps<"svg">;

const TopicIcon = ({ variant, ...rest }: TopicIconProps) => {
  switch (variant) {
    case "review":
      return <TopicReview {...rest} />;
    case "sport":
      return <TopicSport {...rest} />;
    case "food":
      return <TopicFood {...rest} />;
    case "travel":
      return <TopicTravel {...rest} />;
    case "pregnancy":
      return <TopicPregnancy {...rest} />;
    case "children":
      return <TopicChildren {...rest} />;
    case "everyday":
      return <TopicEveryday {...rest} />;
    default:
      return null;
  }
};

export default TopicIcon;
